<template>
  <div>
    <TaxInquiryReportComp />

  </div>
</template>

<script>
import TaxInquiryReportComp from '../../../components/tax/TaxInquiry/Reports/TaxInquiryReportComp.vue';

export default {
  name: 'TaxInquiryReport',
  components: {
    TaxInquiryReportComp,
  },
};

</script>
